import dialogPolyfill from 'dialog-polyfill';

/**
 * Search Modal
 *
 * Generates a dialog element for the search modal when the search icon is clicked
 *
 */
function searchModal() {
	const searchDialog = document.getElementById('search-modal');

	// Return early if the search modal doesn't exist.
	if (!searchDialog) {
		return;
	}

	dialogPolyfill.registerDialog(searchDialog);

	// add the event listener for the search close button
	const searchCloseButton = searchDialog.querySelector(
		'[data-action="close-search-modal"]'
	);
	searchCloseButton.addEventListener('click', function () {
		searchDialog.close();
	});

	// close modal on escape key press
	window.addEventListener('keydown', function (event) {
		if (event.key === 'Escape') {
			searchDialog.close();
		}
	});

	// close modal on click outside modal
	window.addEventListener('click', function (event) {
		if (event.target === searchDialog) {
			searchDialog.close();
		}
	});

	const searchButtons = document.querySelectorAll(
		'[data-action="open-search-modal"]'
	);
	searchButtons.forEach((button) => {
		button.addEventListener('click', function (event) {
			event.preventDefault();

			if (searchDialog) {
				searchDialog.showModal();
			}
		});
	});
}

export { searchModal };
